import { Skeleton } from "@material-ui/lab";
import { Duration } from "luxon";
import React from "react";
import roundToNearest from "./utils/roundToNearest";

type Props = {
  loading: boolean;
  weeklyAverage: Duration;
};

const OneOnOneGuidance = ({ loading, weeklyAverage }: Props) => {
  if (loading)
    return (
      <div cw-id="hoursPerWeek" className="cw-body-base cw-mb-3" aria-busy="true">
        <Skeleton variant="text" />
        <Skeleton variant="text" width="25%" />
      </div>
    );

  const totalMinutes = roundToNearest(5)(Math.floor(weeklyAverage.as("minutes")));
  const hours = Math.floor(totalMinutes / 60);
  const minutes = totalMinutes % 60;

  const hoursText = hours > 0 ? `${hours}h ` : "";
  const minutesText = minutes > 0 ? `${minutes}m ` : "";
  const durationText = hoursText || minutesText ? `${hoursText}${minutesText}` : "0h ";

  return (
    <div cw-id="hoursPerWeek" className="cw-body-base cw-mb-3" aria-busy="false">
      <span cw-id="hoursPerWeek" className="cw-font-semibold">
        You have {durationText}of one-on-ones each week.
      </span>{" "}
      Mark one-on-ones flexible to create Focus Time for you and your team.
    </div>
  );
};

export default OneOnOneGuidance;
